import {
  Box,
  Image,
  Heading,
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  HStack,
  Divider,
  Circle,
  VStack,
  IconButton,
  // Link,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { ReactComponent as Logout } from '../../assets/sidebar/logout.svg';

import { useAppDispatch, useTypedSelector } from '../../hooks';
import { useNavigate } from 'react-router-dom';

import { logout } from '../../modules/auth';
import { sidebarContent } from './sidebar-content';

function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { userName } = useTypedSelector(state => state.auth);

  return (
    <Box mx="6">
      <Heading color="custom_blue.1" fontSize="3xl" h="10vh">
        <Box as="span" color="custom_orange.2">
          Cross
        </Box>
        Buildz.
      </Heading>

      <Accordion className="hidden-scroll" h="calc(100vh - 33vh)">
        {sidebarContent.map(content => (
          <AccordionItem
            key={content.name}
            border="none"
            borderRadius="md"
            mt={content.name === 'Settings' ? '16' : '0'}
          >
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    color="custom_blue.1"
                    _expanded={{ bg: 'custom_orange.2', color: 'white' }}
                    onClick={() => navigate('/' + content.link)}
                    borderRadius="md"
                  >
                    <HStack flex="1" gap="3">
                      {content.icon && (
                        <Image
                          src={`/sidebar/${
                            content.icon + (isExpanded ? '-selected' : '')
                          }.svg`}
                          alt={content.name + 'icon'}
                        />
                      )}
                      <Box fontWeight="medium">{content.name}</Box>
                    </HStack>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>

                {content.nestedLink && content.nestedLink.length && (
                  <AccordionPanel pb={4}>
                    {content.nestedLink.map(({ name, link }) => (
                      <UnorderedList key={name}>
                        <ListItem>
                          <Box color="custom_blue.1">
                            <Link to={`/${link}`}>{name}</Link>
                          </Box>
                        </ListItem>
                      </UnorderedList>
                    ))}
                  </AccordionPanel>
                )}
              </>
            )}
          </AccordionItem>
        ))}
      </Accordion>

      <Divider bg="custom_gray.4" />

      <HStack h="20vh">
        <Circle size="10" bg="custom_blue.3"></Circle>

        <VStack align="start">
          <Box
            color="custom_blue.1"
            fontSize="md"
            fontWeight="semibold"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            maxW="32"
          >
            {userName}
          </Box>
          <Box color="custom_blue.1" fontSize="sm">
            User.crossbuildz.app
          </Box>
        </VStack>
        <IconButton
          onClick={() => {
            dispatch(logout());
            ['accessToken', 'refreshToken', 'userName'].forEach(key =>
              localStorage.removeItem(key)
            );
          }}
          aria-label="logout"
          bg="none"
          _hover={{ bg: 'none' }}
          icon={<Logout />}
        />
      </HStack>
    </Box>
  );
}

export default Sidebar;
